import { NavigationButtons } from "@/components/NavigationButtons/NavigationButtons";
import {
  useCurrentUploadId,
  useCurrentUploadQuery,
  useUploadUpdateMutation,
} from "@/hooks/uploads";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ConfirmFilesOriginality } from "./ConfirmFilesOriginality";
import { ValidationError } from "./ValidationError";

export function VideoFilesConfirmation() {
  const navigate = useNavigate();
  const uploadId = useCurrentUploadId();
  const uploadMutation = useUploadUpdateMutation();
  const currentUploadQuery = useCurrentUploadQuery();
  const [isValid, setIsValid] = useState(true);
  const [selectedRadioBtn, setSelectedRadioBtn] = useState<boolean | null>(
    null,
  );

  useEffect(() => {
    if (currentUploadQuery.data) {
      if (currentUploadQuery.data.allOriginalConfirmation !== null) {
        setSelectedRadioBtn(currentUploadQuery.data.allOriginalConfirmation);
      }
    }
  }, [currentUploadQuery.data]);

  const isPending = uploadMutation.isPending;

  const saveFilesConfirmation = async () => {
    if (selectedRadioBtn === null) {
      setIsValid(false);
      return;
    }
    await uploadMutation.mutateAsync({
      id: Number(uploadId),
      updateUploadDto: {
        allOriginalConfirmation: selectedRadioBtn,
      },
    });

    if (!isPending) {
      navigate(`/uploads/${uploadId}/mandatory-video-metadata`);
    }
  };

  return (
    <>
      <ConfirmFilesOriginality
        radioBtnState={selectedRadioBtn}
        disabled={false}
        onChange={(value) => {
          setSelectedRadioBtn(value);
          setIsValid(true);
        }}
      />
      <section className="my-space250 ml-auto flex flex-row items-center">
        {!isValid && <ValidationError message="Choice is required" />}
        <NavigationButtons
          onPrev={() => {}}
          disabledPrev={true}
          nextButtonTitle={isPending ? "Processing..." : "Continue"}
          onContinue={() => saveFilesConfirmation()}
        />
      </section>
    </>
  );
}
